import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MainLoader = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.authState);

  useEffect(() => {
    setTimeout(() => {
      if (state.loggedIn) {
        navigate(`/courses`);
      } else {
        navigate("/");
      }
    }, 200);
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center w-100"
      style={{ height: "100dvh" }}
    >
      <div
        className="spinner-border spinner-border-md text-danger mx-auto my-auto"
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};
export default MainLoader;
